export const GENERIC_TEMPLATE_SEO_BY_PATH = {
    "/lexique": {
        title: "Lexique du crowdlending",
    },
    "/taux-de-rendement-interne": {
        title: "Taux de Rendement Interne (TRI)",
        description: "Comprendre le TRI (Taux de Rendement Interne) : definition, calcul et interpretation pour evaluer la performance d'un investissement en crowdlending.",
    },
    "/mentions-legales": {
        title: "Mentions legales",
        description: "Mentions legales PretUp : informations editeur, hebergement, propriete intellectuelle et cadre reglementaire de la plateforme de financement participatif.",
    },
    "/nous-recrutons": {
        title: "Nous recrutons",
    },
    "/politique-de-confidentialite": {
        title: "Politique de confidentialite",
        description: "Politique de confidentialite PretUp : donnees collectees, finalites, duree de conservation et droits conformement au RGPD.",
    },
    "/a-propos-de": {
        title: "A propos",
        description: "A propos de PretUp : notre mission, notre approche du financement participatif et comment nous accompagnons preteurs et entreprises.",
    },
    "/actualites": {
        title: "Actualites",
    },
    "/partenaires": {
        title: "Partenaires",
        description: "Partenaires PretUp : decouvrez les acteurs qui nous accompagnent pour proposer une experience d'investissement et de financement fiable et transparente.",
    },
    "/cgu": {
        title: "Conditions generales d'utilisation",
        description: "Conditions generales d'utilisation PretUp : regles d'acces, creation de compte, services, responsabilites et informations essentielles pour utiliser la plateforme.",
    },
    "/reclamation": {
        title: "Reclamation",
    },
    "/communique-de-presse": {
        title: "Communique de presse",
    },
    "/preter/methodes-de-cotation": {
        title: "Methodes de cotation",
    },
    "/preter/methodes-de-cotation/selection-des-pme": {
        title: "Selection des PME",
    },
    "/preter/methodes-de-cotation/analyse-financiere": {
        title: "Analyse financiere",
    },
    "/preter/methodes-de-cotation/cotation": {
        title: "Cotation",
    },
    "/preter/methodes-de-cotation/tarification": {
        title: "Tarification",
    },
    "/preter/methodes-de-cotation/organes-de-decision": {
        title: "Organes de decision",
    },
    "/preter/methodes-de-cotation/suivi-des-financements": {
        title: "Suivi des financements",
    },
    "/garanties": {
        title: "Garanties",
    },
    "/fiscalite": {
        title: "Fiscalite",
    },
    "/avis-clients": {
        title: "Avis clients",
    },
    "/financement-solidaire---associations": {
        title: "Financement solidaire - associations",
    },
};

export const FAQ_SEO_BY_PATH = {
    "/preter/faq-preteur": {
        title: "FAQ preteur",
        description: "FAQ preteur PretUp : fonctionnement du crowdlending, risques, rendement, fiscalite, diversification et etapes pour investir sur la plateforme.",
    },
    "/emprunter/faq-emprunteur": {
        title: "FAQ emprunteur",
        description: "FAQ emprunteur PretUp : conditions, etapes, documents, couts et delais. Tout savoir pour financer votre entreprise via le pret participatif.",
    },
};

export const REGISTER_SEO_BY_PATH = {
    "/inscription/preteur": {
        title: "Inscription preteur",
        description: "Creez votre compte preteur PretUp et commencez a investir en crowdlending. Diversifiez vos prets et accedez aux opportunites de financement.",
    },
    "/preter/ouvrez-votre-compte-pretup": {
        title: "Ouvrir un compte preteur",
        description: "Ouvrez votre compte preteur PretUp en quelques minutes. Investissez dans des entreprises selectionnees et suivez vos investissements en ligne.",
    },
};
